import Component from '@galactic-advisors/component-loader';

const DEFAULTS = {
  nameElement: '[name="name"]',
  codeElement: '[name="code"]',
};

export default class EasyAssessments extends Component {
  static selector = '[data-comp-easy-assessment]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    this.init();
    this.generateCodeFromName();
  }

  init() {
    this.nameElement = this.$container.querySelector(
      this.$options.nameElement
    );

    this.codeElement = this.$container.querySelector(
      this.$options.codeElement
    );
  }

  generateCodeFromName() {
    this.nameElement.addEventListener('blur', () => {
      const name = this.nameElement.value;

      if (this.codeElement.value !== '') {
        return;
      }

      if (name === '') {
        return;
      }

      const strippedName = name.replace(/[^A-Za-z0-9]/g, '');
      this.codeElement.value = strippedName;
    });
  }
}
